import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';
import {
  TOPBAR_DROPDOWN_ALIGN_LEFT,
  TOPBAR_DROPDOWN_ALIGN_RIGHT,
  TOPBAR_DROPDOWN_ALIGN_FULLWIDTH,
} from '../../../../ReduxStorage/TopBar/constants';
import { LayoutSizeListener } from '../../../layout-size-listener/layout-size-listener';

export class TopBarDropdown extends PureComponent {
  static propTypes = {
    clearTopBarExpendedMenu: PropTypes.func.isRequired,
    updateTopBarExpendedMenuAlignment: PropTypes.func.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    menu: PropTypes.string.isRequired,
    expandedMenu: PropTypes.string,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    computedAlignment: PropTypes.oneOf([
      TOPBAR_DROPDOWN_ALIGN_LEFT,
      TOPBAR_DROPDOWN_ALIGN_RIGHT,
      TOPBAR_DROPDOWN_ALIGN_FULLWIDTH,
    ]),
    defaultAlignment: PropTypes.oneOf([
      TOPBAR_DROPDOWN_ALIGN_LEFT,
      TOPBAR_DROPDOWN_ALIGN_RIGHT,
      TOPBAR_DROPDOWN_ALIGN_FULLWIDTH,
    ]),
    constrainedbyScreenHeight: PropTypes.bool,
  };

  static defaultProps = {
    className: null,
    expandedMenu: null,
    children: null,
    onShow: null,
    onHide: null,
    computedAlignment: TOPBAR_DROPDOWN_ALIGN_LEFT,
    defaultAlignment: TOPBAR_DROPDOWN_ALIGN_LEFT,
    constrainedbyScreenHeight: true,
  };

  componentDidUpdate(prevProps) {
    const { expandedMenu, menu, onShow, onHide } = this.props;

    const prevPropsShow = prevProps.expandedMenu === prevProps.menu;
    const show = expandedMenu === menu;

    if (show !== prevPropsShow) {
      if (show) {
        this.onWindowResize();
        LayoutSizeListener.bind(this.onWindowResize);

        // set timeout so the click that expands the dropdown won't
        // close the dropdown straight away
        setTimeout(() => {
          window.addEventListener('click', this.onWindowClick);
          window.addEventListener('touchend', this.onWindowClick);
          window.addEventListener('keydown', this.onKeyPress);
        }, 0);

        if (onShow) {
          onShow();
        }
      } else {
        LayoutSizeListener.unbind(this.onWindowResize);
        window.removeEventListener('click', this.onWindowClick);
        window.removeEventListener('touchend', this.onWindowClick);
        window.addEventListener('keydown', this.onKeyPress);

        if (onHide) {
          onHide();
        }
      }
    }
  }

  onWindowResize = () => {
    const { updateTopBarExpendedMenuAlignment, defaultAlignment } = this.props;

    const dropDownComponentBounding = this.dropDownComponent.getBoundingClientRect();
    const dropDownBounding = this.dropDown.getBoundingClientRect();

    // calculate the right edge of the dropDown if it was aligned
    // to the left of the parent button
    const rightEdge = dropDownComponentBounding.left + dropDownBounding.width;

    // calculate the left edge of the dropDown if it was aligned
    // to the right of the parent button
    const leftEdge = dropDownComponentBounding.right - dropDownBounding.width;

    const windowWidth =
      window.innerWidth || document.documentElement.clientWidth;

    const rightAlignWillFit = leftEdge > 0;
    const leftAlignWillFit = rightEdge < windowWidth;

    if (!rightAlignWillFit && !leftAlignWillFit) {
      updateTopBarExpendedMenuAlignment(TOPBAR_DROPDOWN_ALIGN_FULLWIDTH);
      return;
    }

    switch (defaultAlignment) {
      case TOPBAR_DROPDOWN_ALIGN_LEFT:
        updateTopBarExpendedMenuAlignment(
          leftAlignWillFit
            ? TOPBAR_DROPDOWN_ALIGN_LEFT
            : TOPBAR_DROPDOWN_ALIGN_RIGHT
        );
        break;
      case TOPBAR_DROPDOWN_ALIGN_RIGHT:
        updateTopBarExpendedMenuAlignment(
          rightAlignWillFit
            ? TOPBAR_DROPDOWN_ALIGN_RIGHT
            : TOPBAR_DROPDOWN_ALIGN_LEFT
        );
        break;
      case TOPBAR_DROPDOWN_ALIGN_FULLWIDTH:
      default:
        updateTopBarExpendedMenuAlignment(TOPBAR_DROPDOWN_ALIGN_FULLWIDTH);
    }
  };

  onWindowClick = (event) => {
    const { clearTopBarExpendedMenu } = this.props;
    const dropdownElement = this.dropDown;

    if (
      event.target !== dropdownElement &&
      !dropdownElement.contains(event.target)
    ) {
      // stop onWindowClick being triggered twice by click and touchstart
      event.stopPropagation();
      event.preventDefault();

      clearTopBarExpendedMenu();
    }
  };

  onKeyPress = (event) => {
    const { clearTopBarExpendedMenu } = this.props;

    if (event.key === 'Escape') {
      clearTopBarExpendedMenu();
    }
  };

  render() {
    const {
      children,
      className,
      computedAlignment,
      constrainedbyScreenHeight,
      expandedMenu,
      menu,
    } = this.props;

    const show = expandedMenu === menu;

    return (
      <top-bar-dropdown
        className="top-bar-dropdown-component"
        ref={(elem) => {
          this.dropDownComponent = elem;
        }}
      >
        <div
          className={classNames('top-bar-dropdown', className, {
            'top-bar-dropdown-screen-height': constrainedbyScreenHeight,
            'top-bar-dropdown-show': show,
            'top-bar-dropdown-right':
              computedAlignment === TOPBAR_DROPDOWN_ALIGN_RIGHT,
            'top-bar-dropdown-left':
              computedAlignment === TOPBAR_DROPDOWN_ALIGN_LEFT,
            'top-bar-dropdown-fullwidth':
              computedAlignment === TOPBAR_DROPDOWN_ALIGN_FULLWIDTH,
          })}
          ref={(elem) => {
            this.dropDown = elem;
          }}
        >
          {children}
        </div>
        <div
          className={classNames('top-bar-dropdown-backdrop', {
            'top-bar-dropdown-backdrop-show': show,
          })}
        />
      </top-bar-dropdown>
    );
  }
}
